import { render, staticRenderFns } from "./ProducaoPaciente.vue?vue&type=template&id=21f1dd7c"
import script from "./ProducaoPaciente.vue?vue&type=script&lang=ts"
export * from "./ProducaoPaciente.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports